<template>
  <div>
    <template>
      <v-card
        class="mx-auto contact-card"
      >
        <GmapMap
          :center="{lat:  parseFloat(contact.lat), lng:  parseFloat(contact.lng)}"
          :zoom="10"
          map-type-id="terrain"
          style="width: 100%; height: 300px"
        >
          <GmapMarker
            ref="marker"
            :position="{ lat:  parseFloat(contact.lat), lng:  parseFloat(contact.lng) }"
          />
        </GmapMap>

        <v-list class="contact__page-listing" two-line>
          <v-list-item>
            <p v-html="contact.introduction"></p>
          </v-list-item>

          <v-list-item  class="contact__page-listing-item" :class="item.element" :key="item.id" v-for="item in contact.items" @click="handleContentClick($event)" ripple>
            <v-list-item-icon>
              <v-icon v-if="item.element == 'phonenumber'" color="primary">mdi-phone</v-icon>
              <v-icon v-else-if="item.label == 'Name' || item.label == 'Address'" color="primary">mdi-map-marker</v-icon>
              <v-icon v-else-if="item.element == 'website'" color="primary">mdi-earth</v-icon>
              <v-icon v-else-if="item.element == 'email'" color="primary">mdi-email heel</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-subtitle v-if="item.element != 'address'">{{item.label}}</v-list-item-subtitle>
              <v-list-item-subtitle v-else-if="item.label == contact.items[3].label">{{translations.catagories.address}}</v-list-item-subtitle>
              <a v-if="item.element == 'email'" :href="'mailto:' + item.content">{{item.content}}</a>
              <a v-else-if="item.element == 'phonenumber'" target="_blank" :href="'tel:' + item.content">{{item.content}}</a>
              <a v-else-if="item.element == 'website'" :href="'http://' + item.content">{{item.content}}</a>
              <v-list-item-title :class="[item.label === 'Address' ? 'address-field' : '']" v-else>{{item.content}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";

export default {
  data: () => ({
  }),
  computed: {
    contact() {
      return hubbdata.getters.contact
    },
    translations() {
      return hubbdata.getters.translations;
    },
  },
  mounted: function() {
    ga('set', 'title', "Contact Us"); // eslint-disable-line
    ga('send', 'pageview', location.href); // eslint-disable-line
  }
}
</script>

<style lang="scss">
.contact {

  &__page-listing {

    @media (min-width: 1020px) {
      max-width: 80%;
      margin: 0 auto;
    }
  }

  &__page-listing-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    &:last-child {
      border-bottom: none;
    }
  }
}

.contact-card {
  height: calc(100vh - 56px);

  .v-list-item__title,
  .v-list-item__subtitle {
    text-overflow: unset;
    white-space: unset;
  }
}

.v-list {
  padding-bottom: 60px;
}

.mdi-map-marker {
  display: none;
}

a {
  text-decoration: underline;
}
</style>
